import { z } from "zod";
import {
  insertAction,
  updateAction,
} from "@/pages/admin/rules/actions/lib/mutations";

const ActionSchema = z.object({
  rule: z.string().min(1, { message: "Regel is verplicht" }),
  ruleActionType: z.string().min(1, { message: "Actie type is verplicht" }),
  name: z.string().min(2, { message: "Naam is verplicht" }),
  description: z.string(),
  data: z.string(),
  priority: z.coerce
    .number()
    .int({ message: "Prioriteit moet een getal zijn" })
    .min(0, { message: "Prioriteit moet een positief getal zijn" }),
  active: z.coerce.boolean(),
  delayInSeconds: z.coerce
    .number()
    .int({ message: "Prioriteit moet een getal zijn" })
    .min(0, { message: "Prioriteit moet een positief getal zijn" }),
  synchronous: z.coerce.boolean(),
});

export const createAction = async (formData, redirect) => {
  const validatedFields = ActionSchema.safeParse({
    rule: formData.rule,
    ruleActionType: formData.ruleActionType,
    name: formData.name,
    description: formData.description,
    data: formData.data,
    priority: formData.priority,
    active: formData.active,
    delayInSeconds: formData.delayInSeconds,
    synchronous: formData.synchronous,
  });

  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
      message: "Er missen velden.",
    };
  }

  try {
    await insertAction(validatedFields.data);
  } catch {
    return {
      message: "Er is iets misgegaan.",
    };
  }

  redirect("/rules/actions");
};

export const editAction = async (id, formData, redirect) => {
  const validatedFields = ActionSchema.safeParse({
    rule: formData.rule,
    ruleActionType: formData.ruleActionType,
    name: formData.name,
    description: formData.description,
    data: formData.data,
    priority: formData.priority,
    active: formData.active,
    delayInSeconds: formData.delayInSeconds,
    synchronous: formData.synchronous,
  });

  if (!validatedFields.success) {
    return {
      errors: validatedFields.error.flatten().fieldErrors,
      message: "Er missen velden.",
    };
  }

  const actionData = {
    id,
    ...validatedFields.data,
  };

  try {
    await updateAction(actionData);
  } catch (err) {
    console.error(err);
    return {
      message: "Er is iets misgegaan.",
    };
  }

  redirect("/rules/actions");
};
